export const initialFormValues = {
  grouping: '',
  descriptionId: '',
  grossUnitValue: '',
  tax: '',
  totalQuantity: '',
  grossTotal: '',
  netTotal: '',
  days: []
}
